import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';

class Footer extends React.Component {
    render() {

        return (
            <>
                <footer className="site-footer footer-large  footer-dark	footer-wide">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="widget widget_about">
                                        {/*<h4 class="widget-title">About Company</h4>*/}
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"./"}>
                                                <img src={require('./../../images/logo-light.png')} alt="Inteshape" />
                                            </NavLink>
                                        </div>
                                        <p>A professionally managed construction company with extensive experience in executing large- and medium-scale residential, commercial, and industrial projects. The company is committed to excellence in every aspect of its operations, striving to deliver projects that meet the highest standards of quality and efficiency.</p>
                                            {/* <ul className="social-icons sx-social-links">
                                                <li><NavLink to={"https://www.behance.net"} className="fa fa-behance" target="_blank"></NavLink></li>
                                                <li><NavLink to={"https://www.facebook.com"} className="fa fa-facebook" target="_blank"></NavLink></li>
                                                <li><NavLink to={"https://twitter.com"} className="fa fa-twitter" target="_blank"></NavLink></li>
                                                <li><NavLink to={"https://www.instagram.com"} className="fa fa-instagram" target="_blank"></NavLink></li>
                                            </ul> */}
                                    </div>
                                </div>
                                {/* USEFUL LINKS */}
                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">Useful links</h5>
                                        <ul>
                                            <li><NavLink to={"/about-us"}>About Us</NavLink></li>
                                            <li><NavLink to={"/projects"}>Projects</NavLink></li>
                                            <li><NavLink to={"/careers"}>Careers</NavLink></li>
                                            <li><NavLink to={"/gallery"}>Gallery</NavLink></li>
                                            {/* <li><NavLink to={"/contact-us"}>Contact Us</NavLink></li> */}
                                        </ul>
                                    </div>
                                </div>
                                {/* CONTACT US */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h5 className="widget-title">Contact Us</h5>
                                        <ul className="widget_address">
                                            <li>6, Santi Pally, BA - 52 Rajdanga Sarat Park, Kolkata - 700 107</li>
                                            <li>info@madhubancontracts.com</li>
                                            <li>+91 70031 65967</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="sx-footer-bot-left">
                                    <span className="copyrights-text">© 2025 | Madhuban Contracts LLP</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <Switcher/>

            </>
        );
    };
};

export default Footer;